"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginCheckout = exports.loginGuest = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const createUrl_1 = require("../../utils/createUrl");
const API_BACKEND_BASIC_AUTH = 'Basic Y3VzdG9tZXItYXBwOmN1c3RvbWVyLXNlY3JldA==';
const urlMapping = {
    loginGuest: {
        client: 'api/buy/login',
    },
    loginCheckout: {
        client: 'api/oauth/login/checkout',
    },
};
const loginGuest = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { username, exploreMoreCardNumber }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.loginGuest, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        withCredentials: true,
        headers: {
            Authorization: API_BACKEND_BASIC_AUTH,
        },
        params: defaultRequestParams,
        data: { username, exploreMoreCardNumber },
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.loginGuest = loginGuest;
const loginCheckout = (_c, _d) => tslib_1.__awaiter(void 0, [_c, _d], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { username, password, keepSignedIn }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.loginCheckout, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        withCredentials: true,
        headers: {
            Authorization: API_BACKEND_BASIC_AUTH,
        },
        params: Object.assign(Object.assign({}, defaultRequestParams), { keepSignedIn }),
        data: {
            username,
            password,
        },
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.loginCheckout = loginCheckout;
//# sourceMappingURL=auth.api.js.map